import * as React from 'react'
import type { PlantEquipment } from '@axilon-apps/domains-ontology-ui-state'
import { EquipmentTile } from '../EquipmentTile'
import { SectionHeader } from '../entity/SectionHeader'

export function SubEquipmentSection({
  equipment
}: {
  equipment: PlantEquipment[]
}): React.ReactElement | null {
  if (equipment.length === 0) return null

  return (
    <section>
      <SectionHeader
        label="Sub-equipment"
        subtitle={`${equipment.length} ${equipment.length === 1 ? 'piece' : 'pieces'}`}
      />
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-[repeat(auto-fill,minmax(16.25rem,1fr))]">
        {equipment.map((item) => (
          <EquipmentTile key={item.id} equipment={item} />
        ))}
      </div>
    </section>
  )
}
